import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useStatisticsDashboard(params) {
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/statistics/dashboard`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useStatisticsDashboard;
